/**
 * Per-aircraft link status.
 *
 * Which transports are carrying an aircraft and which one is primary. Today the
 * ingest binds one link per aircraft, so this shows one link and names it
 * primary; the multi-link failover the routing brain supports needs a second
 * physical transport to exercise.
 */

import { api, type ApiResult } from '@/api/client';

export type LinkHealth = 'live' | 'stale' | 'dead';

export interface LinkState {
  linkId: string;
  health: LinkHealth;
  lastMessageAt: number | null;
  priority: number;
}

export interface AircraftLinks {
  droneId: string;
  primaryLink: string | null;
  links: LinkState[];
}

export function getLinks(): Promise<ApiResult<{ aircraft: AircraftLinks[]; multiLink: boolean }>> {
  return api.get<{ aircraft: AircraftLinks[]; multiLink: boolean }>('/links', { logged: false });
}
